// Theme: jade-dragon-aether
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'jade-dragon-aether',
  name: 'JADE DRAGON AETHER',
  tagline: 'JADE DRAGON AETHER',
  description: 'Estrutura Jade Dragon com paleta aether clara.',
  category: 'fantasy-realms',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#081713', '#102520', '#2DD4BF', '#D8FCEE'],
  familyId: 'jade-dragon',
  variantName: 'AETHER',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-sans theme-jade-dragon-aether'
  },
  colorVars: {
    '--accent': '#2DD4BF',
    '--accent-foreground': '#081713',
    '--background': '#081713',
    '--border': '#7A6830',
    '--card': '#102520',
    '--card-border-active': 'rgba(212,175,55,0.55)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#D8FCEE',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#081713',
    '--foreground': '#D8FCEE',
    '--hold-fill': '#2DD4BF',
    '--input': '#4E3E18',
    '--modal-bg': '#081713',
    '--modal-border': '#7A6830',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#2E2408',
    '--muted-foreground': '#D4AF37',
    '--nav-active': '#2DD4BF',
    '--nav-bg': '#102520',
    '--popover': '#102520',
    '--popover-foreground': '#D8FCEE',
    '--primary': '#2DD4BF',
    '--primary-foreground': '#081713',
    '--ring': '#D4AF37',
    '--secondary': '#1C1A08',
    '--secondary-foreground': '#D4AF37',
    '--streak': '#D4AF37',
    '--success': '#22c55e',
    '--success-foreground': '#081713',
    '--xp': '#D4AF37',
    '--xp-bg': '#102520'
  },
  resolvedVars: {
    '--accent': '#2DD4BF',
    '--accent-foreground': '#081713',
    '--accent-foreground-hsl': '164 48% 6%',
    '--accent-foreground-oklch': 'from #081713 l c h',
    '--accent-hsl': '172 66% 50%',
    '--accent-oklch': 'from #2DD4BF l c h',
    '--background': '#081713',
    '--background-hsl': '164 48% 6%',
    '--background-oklch': 'from #081713 l c h',
    '--border': '#7A6830',
    '--border-hsl': '45 44% 33%',
    '--border-oklch': 'from #7A6830 l c h',
    '--border-w': '1px',
    '--card': '#102520',
    '--card-border-active': 'rgba(212,175,55,0.55)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#D8FCEE',
    '--card-foreground-hsl': '157 86% 92%',
    '--card-foreground-oklch': 'from #D8FCEE l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '166 40% 10%',
    '--card-oklch': 'from #102520 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#081713',
    '--destructive-foreground-hsl': '164 48% 6%',
    '--destructive-foreground-oklch': 'from #081713 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#D8FCEE',
    '--foreground-hsl': '157 86% 92%',
    '--foreground-oklch': 'from #D8FCEE l c h',
    '--hold-fill': '#2DD4BF',
    '--hold-fill-hsl': '172 66% 50%',
    '--hold-fill-oklch': 'from #2DD4BF l c h',
    '--input': '#4E3E18',
    '--input-hsl': '42 53% 20%',
    '--input-oklch': 'from #4E3E18 l c h',
    '--modal-bg': '#081713',
    '--modal-bg-hsl': '164 48% 6%',
    '--modal-bg-oklch': 'from #081713 l c h',
    '--modal-border': '#7A6830',
    '--modal-border-hsl': '45 44% 33%',
    '--modal-border-oklch': 'from #7A6830 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#2E2408',
    '--muted-foreground': '#D4AF37',
    '--muted-foreground-hsl': '46 65% 52%',
    '--muted-foreground-oklch': 'from #D4AF37 l c h',
    '--muted-hsl': '44 70% 11%',
    '--muted-oklch': 'from #2E2408 l c h',
    '--nav-active': '#2DD4BF',
    '--nav-active-hsl': '172 66% 50%',
    '--nav-active-oklch': 'from #2DD4BF l c h',
    '--nav-bg': '#102520',
    '--nav-bg-hsl': '166 40% 10%',
    '--nav-bg-oklch': 'from #102520 l c h',
    '--popover': '#102520',
    '--popover-foreground': '#D8FCEE',
    '--popover-foreground-hsl': '157 86% 92%',
    '--popover-foreground-oklch': 'from #D8FCEE l c h',
    '--popover-hsl': '166 40% 10%',
    '--popover-oklch': 'from #102520 l c h',
    '--primary': '#2DD4BF',
    '--primary-foreground': '#081713',
    '--primary-foreground-hsl': '164 48% 6%',
    '--primary-foreground-oklch': 'from #081713 l c h',
    '--primary-hsl': '172 66% 50%',
    '--primary-oklch': 'from #2DD4BF l c h',
    '--radius': '12px',
    '--ring': '#D4AF37',
    '--ring-hsl': '46 65% 52%',
    '--ring-oklch': 'from #D4AF37 l c h',
    '--secondary': '#1C1A08',
    '--secondary-foreground': '#D4AF37',
    '--secondary-foreground-hsl': '46 65% 52%',
    '--secondary-foreground-oklch': 'from #D4AF37 l c h',
    '--secondary-hsl': '54 56% 7%',
    '--secondary-oklch': 'from #1C1A08 l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#D4AF37',
    '--streak-hsl': '46 65% 52%',
    '--streak-oklch': 'from #D4AF37 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#081713',
    '--success-foreground-hsl': '164 48% 6%',
    '--success-foreground-oklch': 'from #081713 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(172 66% 50% / 0.15)',
    '--xp': '#D4AF37',
    '--xp-bg': '#102520',
    '--xp-bg-hsl': '166 40% 10%',
    '--xp-bg-oklch': 'from #102520 l c h',
    '--xp-hsl': '46 65% 52%',
    '--xp-oklch': 'from #D4AF37 l c h'
  }
}
